module.exports = "<div>\n\n    <h1 class=\"reports__header\" translate>Schedule a New Report</h1>\n\n    <table class=\"table report-table\">\n        <tbody>\n        <tr>\n            <td>Accountancy Report\n            </td>\n            <td>\n                <button id=\"viewPartnerAccountancyReport\"\n                        class=\"btn btn-success pull-right\" ng-click=\"vm.schedulePartnerAccountancyReport()\" translate>\n                    Schedule\n                </button>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/reports/partner/schedule/schedule.html
// module id = 427
// module chunks = 0